import {UUID} from '@/plugins/common'
import _ from 'lodash'
import Action from './action'
// import { FormComponent } from '../form/component'
import Candidate from './candidate'
export default class Node {
  id = ''
  // 名字
  name = ''
  // 分组 [userTask, cancelEvent, endEvent, inclusiveGateway_start, inclusiveGateway_end]
  type = ''
  // 表单
  formId=''
  // 按钮
  actions = []
  // 候选人 类型 sponsor/superiors/department/post/user/component
  candidates = []
  // 展示节点
  candidateShowNode = ''
  // 必填
  candidateRequired = true
  // 审批意见
  approvalOpinion = true
  // 审批意见是否必填
  approvalOpinionRequired = false
  // 审批信息是否归档
  approvalOpinionArchive=false
  // 位置信息
  position = {x: 0, y: 0}
  // 是否会签节点
  isCountersign =false
  // 会签比例
  countersignRatio = 1
  // 会签绑定同意按钮id
  agreedActionId = ''
  // 会签绑定不同意按钮id
  disAgreedActionId = ''
  // 开启更多
  openMore = false
  // 当前节点审批人不与申请人一致
  canSameAsStarter = false

  constructor (args = {}) {
    _.merge(this, args)
  }

  static createStartNode (args) {
    if (!args.type) {
      throw new Error(`不存在节点类型, 无法增加节点类型.`)
    }
    args.id = '_' + UUID.create()
    let node = new Node(args)
    node.formId = UUID.create()
    node.approvalOpinion = false
    node.actions.push(Action.create({'name': '发起'}))
    return node
  }

  static create (args) {
    if (!args.type) {
      throw new Error(`不存在节点类型, 无法增加节点类型.`)
    }
    if (!args.position && args.type !== 'cancelEvent' && args.type !== 'endEvent') {
      throw new Error('节点缺少位置信息.')
    }
    args.id = '_' + UUID.create()
    let node = new Node(args)
    node.formId = UUID.create()
    node.openMore = !!(node.isCountersign || node.approvalOpinionArchive)
    // 按钮
    if (node.type === 'userTask') {
      node.actions.push(Action.create({'name': '同意'}))
      node.actions.push(Action.create({'name': '不同意'}))
      node.actions.push(Action.create({'name': '返回修改'}))
      // 候选人
      node.candidates.push(Candidate.create({'type': 'starter'}))
    } else {
      node.approvalOpinion = false
    }
    return node
  }

  static load (args) {
    args.position = JSON.parse(args.position)
    args.openMore = !!(args.isCountersign || args.approvalOpinionArchive)
    let node = new Node(args)
    if (args.actions) {
      let actions = []
      args.actions.forEach(m => {
        actions.push(Action.load(m))
      })
      node.actions = actions
    }
    if (args.candidates) {
      let candidates = []
      args.candidates.forEach(m => {
        candidates.push(Candidate.load(m))
      })
      node.candidates = candidates
    }

    return node
  }

  // 增加按钮
  // 防止其他地方调用了该方法，加上默认值
  addButton (action = {name: '未命名'}) {
    this.actions.push(Action.create(action))
  }
}



// WEBPACK FOOTER //
// ./src/store/process/node.js